module.exports = __webpack_public_path__ + "img/coupon.a87c8fd9.svg";